module.exports = __webpack_public_path__ + "img/illus_tutorial_4@2x.25e29702.png";